<template>
  <div v-if="loading" class="loader">
    <b-spinner label="Loading..."></b-spinner>
  </div>
</template>
<script>
export default {
  props: {
    loading: { type: Boolean, default: false }
  }
};
</script>
